import React from "react";

import Hero from "./sections/Hero";
import Tabs from "./sections/Tabs";

const MandatoryRequirementRegister = () => {
  return (
    <>
      <Hero />
      <Tabs />
    </>
  )
}

export default MandatoryRequirementRegister;